var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.condition == 'show')?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveAttribute),expression:"isActiveAttribute"}]},[_vm._t("default")],2)]):_c('div',[(_vm.isActiveAttribute)?_c('div',[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }